// This icon file is generated automatically.
var PlusOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8.26 8.26V2.74h1.48v5.52h5.52v1.48H9.74v5.52H8.26V9.74H2.74V8.26h5.52z", "data-follow-fill": "#858585" } }] }, "name": "plus", "theme": "outlined" };
export default PlusOutlined;
